// Hook para manejar los KPIs de pedidos
// Hook for managing orders KPIs

import { useQuery } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { OrdersKpisApiAdapter, OrdersKpisParams } from '../adapters/OrdersKpisApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';
import { useDashboardFilters } from './useDashboardFilters';

export const useOrdersKpis = (params: OrdersKpisParams = {}) => {
  const { toast } = useToast();
  const { setRefreshingComplete } = useDashboardFilters();
  const ordersKpisAdapter = new OrdersKpisApiAdapter(apiClientWH);

  const {
    data: ordersKpisResponse,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['ordersKpis', params],
    queryFn: () => ordersKpisAdapter.getOrdersKpis(params),
    staleTime: 0, // Sin cache para ver los cambios inmediatamente
    gcTime: 5 * 60 * 1000, // 5 minutos
    onSuccess: () => {
      setRefreshingComplete();
    },
    onError: (error: any) => {
      setRefreshingComplete();
      toast({
        title: 'Error al cargar métricas de pedidos',
        description: error?.message || 'Error inesperado. Inténtalo de nuevo.',
        variant: 'destructive',
      });
    },
  });

  return {
    ordersKpis: ordersKpisResponse?.data || {
      sent: 0,
      pending: 0,
      preparing: 0,
      to_confirm: 0,
      percentage_sent: 0,
    },
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};
